let bankList = [
    {
        value: "工商银行",
        num: 1002
    },
    {
        value: "农业银行",
        num: 1005
    },
    {
        value: "建设银行",
        num: 1003
    },
    {
        value: "中国银行",
        num: 1026
    },
    {
        value: "交通银行",
        num: 1020
    },
    {
        value: "招商银行",
        num: 1001
    },
    {
        value: "邮储银行",
        num: 1066
    },
    {
        value: "民生银行",
        num: 1006
    },
    {
        value: "平安银行",
        num: 1010
    },
    {
        value: "中信银行",
        num: 1021
    },
    {
        value: "浦发银行",
        num: 1004
    },
    {
        value: "兴业银行",
        num: 1009
    },
    {
        value: "光大银行",
        num: 1022
    },
    {
        value: "广发银行",
        num: 1027
    },
    {
        value: "华夏银行",
        num: 1025
    },
    {
        value: "宁波银行",
        num: 1056
    },
    {
        value: "北京银行",
        num: 4836
    },
    {
        value: "上海银行",
        num: 1024
    },
    {
        value: "南京银行",
        num: 1054
    },
    {
        value: "长子县融汇村镇银行",
        num: 4755
    },
    {
        value: "长沙银行",
        num: 4216
    },
    {
        value: "浙江泰隆商业银行",
        num: 4051
    },
    {
        value: "中原银行",
        num: 4753
    },
    {
        value: "企业银行（中国）",
        num: 4761
    },
    {
        value: "顺德农商银行",
        num: 4036
    },
    {
        value: "衡水银行",
        num: 4752
    },
    {
        value: "长治银行",
        num: 4756
    },
    {
        value: "大同银行",
        num: 4767
    },
    {
        value: "河南省农村信用社",
        num: 4115
    },
    {
        value: "宁夏黄河农村商业银行",
        num: 4150
    },
    {
        value: "山西省农村信用社",
        num: 4156
    },
    {
        value: "安徽省农村信用社",
        num: 4166
    },
    {
        value: "甘肃省农村信用社",
        num: 4157
    },
    {
        value: "天津农村商业银行",
        num: 4153
    },
    {
        value: "广西壮族自治区农村信用社",
        num: 4113
    },
    {
        value: "陕西省农村信用社",
        num: 4108
    },
    {
        value: "深圳农村商业银行",
        num: 4076
    },
    {
        value: "宁波鄞州农村商业银行",
        num: 4052
    },
    {
        value: "浙江省农村信用社联合社",
        num: 4764
    },
    {
        value: "江苏省农村信用社联合社",
        num: 4217
    },
    {
        value: "江苏紫金农村商业银行股份有限公司",
        num: 4072
    },
    {
        value: "北京中关村银行股份有限公司",
        num: 4769
    },
    {
        value: "星展银行（中国）有限公司",
        num: 4778
    },
    {
        value: "枣庄银行股份有限公司",
        num: 4766
    },
    {
        value: "海口联合农村商业银行股份有限公司",
        num: 4758
    },
    {
        value: "南洋商业银行（中国）有限公司",
        num: 4763
    }
]
// let bankList = []
// const elements = document.getElementsByTagName("tbody")[0].getElementsByTagName('td')
//
// for (let i = 0; i < elements.length; i=i+2) {
//     if (i !== elements.length - 1) {
//         bankList.push({
//             value: elements[i].innerText.trim(),
//             num: Number(elements[i + 1].innerText.trim())
//         })
//     }
// }
// console.log(bankList)


export default bankList;